import type { BreadcrumbItem } from './breadcrumb-types'

/** Stands in for the folded-away middle of a long trail. Never a real crumb id. */
export const ELLIPSIS_CRUMB_ID = '__breadcrumb-ellipsis__'

/** Longest trail rendered in full. Beyond it the middle folds into one ellipsis crumb. */
export const MAX_VISIBLE_CRUMBS = 5

const TAIL_CRUMB_COUNT = 2

export interface CollapsedTrail {
  /** What the trail renders, with the ellipsis crumb in place of the folded middle. */
  readonly visible: readonly BreadcrumbItem[]
  /** The folded crumbs, root first; empty when nothing was folded. */
  readonly hidden: readonly BreadcrumbItem[]
}

/** Folds the middle of a trail longer than {@link MAX_VISIBLE_CRUMBS} into one ellipsis crumb, keeping the root and the last {@link TAIL_CRUMB_COUNT} crumbs. */
export function collapseCrumbs(items: readonly BreadcrumbItem[]): CollapsedTrail {
  if (items.length <= MAX_VISIBLE_CRUMBS) return { visible: items, hidden: [] }

  const root = items[0]!
  const tail = items.slice(items.length - TAIL_CRUMB_COUNT)
  const hidden = items.slice(1, items.length - TAIL_CRUMB_COUNT)

  return {
    visible: [root, { id: ELLIPSIS_CRUMB_ID, label: '' }, ...tail],
    hidden,
  }
}
